import React, {Component} from "react";
import {
  IonButton, IonButtons,
  IonContent, IonFooter,
  IonHeader, IonIcon, IonInput,
  IonItem,
  IonLabel, IonList, IonModal,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "../common/Common.css"
import {updateResource} from "../common/ApiUtils";
import {create, trash} from "ionicons/icons";

export const TaskForm = ({entity={name: "", fullName: ""}, onSave=f=>f, group}) => {
  let _entity = {
    name: null,
    fullName: null,
    group: group ? group._links.self.href: null,
    soloCount: null,
    soloMinutes : null,
    doubleCount : null,
    doubleMinutes : null
  };

  const submit = e => {
    e.preventDefault();
    const entity = {
      name: _entity.name.value,
      fullName: _entity.fullName.value,
      group: _entity.group,
      soloCount: _entity.soloCount.value ? parseInt(_entity.soloCount.value): null,
      soloMinutes : _entity.soloMinutes.value ? parseInt(_entity.soloMinutes.value): null,
      doubleCount : _entity.doubleCount.value  ? parseInt(_entity.doubleCount.value): null,
      doubleMinutes : _entity.doubleMinutes.value  ? parseInt(_entity.doubleMinutes.value): null,
    }
    onSave(entity);

  };
  return (
      <form onSubmit={submit}>
        <IonList>
          <IonItem>
            <IonLabel position="stacked">Zkratka úlohy</IonLabel>
            <IonInput ref={input => _entity.name = input} value={entity.name} />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Název úlohy</IonLabel>
            <IonInput ref={input => _entity.fullName = input} value={entity.fullName} />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Počet startů ve dvojí</IonLabel>
            <IonInput type={'number'} ref={input => _entity.doubleCount = input} value={entity.doubleCount} />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Počet minut ve dvojí</IonLabel>
            <IonInput type={'number'} ref={input => _entity.doubleMinutes = input} value={entity.doubleMinutes} />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Počet startů v sóle</IonLabel>
            <IonInput type={'number'} ref={input => _entity.soloCount = input} value={entity.soloCount} />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Počet minut v sóle</IonLabel>
            <IonInput type={'number'} ref={input => _entity.soloMinutes = input} value={entity.soloMinutes} />
          </IonItem>
        </IonList>
        <IonFooter>
          <IonButton expand="full" type="submit">Uložit</IonButton>
        </IonFooter>
      </form>
  )
};



class Task extends Component {

  constructor(props) {
    super(props);
    this.state = {
      entity : props.entity,
      editModal: false
    };
    this.onUpdate = this.onUpdate.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    //console.log("nextProps: " + nextProps.toSource());
    if (nextProps.entity._links.self.href !== this.state.entity._links.self.href) {
      this.setState({entity :nextProps.entity});
    }
  }

  showModal() {
    this.setState({
      editModal: true
    })
  }

  closeModal() {
    this.setState({
      editModal: false
    })
  }

  async onUpdate(entityToUpdate) {
    this.closeModal();
    const {entity} = this.state;
    const p = await updateResource(entity._links.self.href, entityToUpdate);
    this.setState({entity: p});
  }

  render() {
    const {entity, editModal } = this.state;
    const {active} = this.props;
    const isActive = entity && active && active.entity && active.entity._links.self.href === entity._links.self.href;
    //console.log("edit modal: " + editModal + " glider s:" + glider.surname + " p glider: " +this.props.glider.surname) ;
    return (
        <>
          { entity ?
              <IonItem color={isActive? 'secondary':''}>
                <IonLabel onClick={() => this.props.setEntity(entity)}>
                  <h2>{entity.name}</h2>
                  <h3>{entity.fullName}</h3>
                </IonLabel>
                <IonButtons slot={'end'}>
                  <IonButton size="small" onClick={() => this.props.deleteEntity(entity)}>
                    <IonIcon icon={trash}/>
                  </IonButton>
                  <IonButton size="small" onClick={() => this.showModal()}>
                    <IonIcon icon={create}/>
                  </IonButton>
                </IonButtons>

                <IonModal isOpen={editModal} backdropDismiss={false}>
                  <IonHeader translucent={true}>
                    <IonToolbar>
                      <IonTitle>Editace úlohy</IonTitle>
                      <IonButtons slot="end">
                        <IonButton onClick={() => this.closeModal()}>Zavřít</IonButton>
                      </IonButtons>
                    </IonToolbar>
                  </IonHeader>
                  <IonContent>
                    <TaskForm entity={entity} onSave={this.onUpdate} group={entity.group}/>
                  </IonContent>
                </IonModal>
              </IonItem>
              :
              <IonItem>
                Chyba
              </IonItem>
          }
        </>

    )
  }
}

export default Task;